import {IHttpService} from "angular";
import {getAbsoluteUrl} from "modules/utils/urlUtill";
import {ActionTypes} from "modules/action_status/model/ActionType";

export const EmailPreviewServiceName = 'EmailPreviewService';

export class EmailPreviewService {

    static instance = [
        '$http',
        EmailPreviewService
    ]

    constructor(private $http: IHttpService) {
    }

    deletePreview() {
        return this.$http.delete(getAbsoluteUrl('api/email-preview'));
    }

    deleteSmsPreview() {
        return this.$http.delete(getAbsoluteUrl('api/sms-preview'));
    }

    updatePreview(opportunityId: number, actionType: ActionTypes) {
        switch (actionType) {
            case ActionTypes.TWILIO_SMS:
                return this.$http.patch(getAbsoluteUrl(`api/sms-preview?opportunityId=${opportunityId}`), {});

            default:
                return this.$http.patch(getAbsoluteUrl(`api/email-preview?opportunityId=${opportunityId}`), {});
        }
    }
}
